import { IconButton, Link } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { IBackButton } from './types'
import colors from '../../../constants/colors'

const BackButton: React.FC<IBackButton> = ({ href, btnText }) => {
  return (
    <Link href={href} underline='none'>
      <IconButton sx={{ color: colors.TAG_BLUE, typography: 'textMedium' }}>
        <ArrowBackIcon fontSize='small' /> {btnText}
      </IconButton>
    </Link>
  )
}

export default BackButton
